import { render, staticRenderFns } from "./LocalTips.vue?vue&type=template&id=51168171"
import script from "./LocalTips.vue?vue&type=script&lang=js"
export * from "./LocalTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports